import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "sidebar-wrapper"
};
const _hoisted_2 = { class: "content-area" };
import { computed } from "vue";
import { useRoute } from "vue-router";
import NavBar from "./presentation/components/NavBar.vue";
import DashboardSidebar from "./presentation/components/dashboard/Sidebar.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const route = useRoute();
        const isLogoutPage = computed(() => route.path === "/session-ended");
        const showSidebar = computed(() => route.path.startsWith("/dashboard"));
        const navBarVariant = computed(() => {
            const path = route.path;
            if (path.startsWith("/dashboard")) {
                return "dashboard";
            }
            else if (path.includes("/payment")) {
                return "payment";
            }
            else {
                return "onboarding";
            }
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                id: "app",
                class: _normalizeClass({
                    'no-layout': isLogoutPage.value,
                    'max-w-7xl mx-auto': navBarVariant.value === 'payment',
                    'dashboard-shell': showSidebar.value,
                })
            }, [
                (showSidebar.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(DashboardSidebar)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_2, [
                    (!isLogoutPage.value)
                        ? (_openBlock(), _createBlock(NavBar, {
                            key: 0,
                            variant: navBarVariant.value
                        }, null, 8 /* PROPS */, ["variant"]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("main", {
                        id: "main-content",
                        class: _normalizeClass(["main-content", { 'no-layout': isLogoutPage.value }])
                    }, [
                        _createVNode(_component_router_view)
                    ], 2 /* CLASS */)
                ])
            ], 2 /* CLASS */));
        };
    }
});
